'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var FieldHintVariantsStyles = {
    hint: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    error: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
};
var FieldHintAlignmentStyles = {
    left: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "]))),
    right: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    text-align: right;\n  "], ["\n    text-align: right;\n  "]))),
};
var StyledFieldHint = styled__default.span(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: italic 12px/22px ", ";\n  padding: 2px 0px 0px 16px;\n  width: 100%;\n  ", ";\n  ", ";\n"], ["\n  font: italic 12px/22px ", ";\n  padding: 2px 0px 0px 16px;\n  width: 100%;\n  ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var variant = _a.variant;
    return FieldHintVariantsStyles[variant];
}, function (_a) {
    var align = _a.align;
    return FieldHintAlignmentStyles[align];
});
var FieldHint = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'hint' : _b, _c = _a.align, align = _c === void 0 ? 'left' : _c, dataCy = _a.dataCy, dataTestId = _a.dataTestId, children = _a.children, restProps = tslib_es6.__rest(_a, ["variant", "align", "dataCy", "dataTestId", "children"]);
    return (React__default.createElement(StyledFieldHint, tslib_es6.__assign({ variant: variant, align: align, "data-cy": dataCy && dataCy + "-" + variant, "data-testid": dataTestId && dataTestId + "-" + variant }, restProps), children));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.FieldHint = FieldHint;
